import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class HeadCircumference extends PrimitiveValueObject<number> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: number): HeadCircumference {
    if (value < 0) {
      throw new Error('正数である必要があります');
    }
    return new HeadCircumference(value);
  }

  /** ラベル */
  static get label(): string {
    return '頭囲(cm)';
  }

  /** プレースホルダー */
  static get placeholder(): string {
    return '10';
  }

  /** バリデーションルール */
  static get validationRule() {
    return {};
  }

  /** キー */
  static get key() {
    return 'headCircumference';
  }

  /** タイプ */
  static get type() {
    return 'number';
  }
}
